import { Ghost } from 'lucide-react';
import {
  Tooltip,
  TooltipTrigger,
  TooltipContent,
  TooltipProvider,
} from '@/components/ui/tooltip';

interface GhostToggleProps {
  showGhosts: boolean;
  onToggle: (value: boolean) => void;
  /** When true, the toggle is shown; when false it is hidden (no ghost objects in scene). */
  hasGhosts?: boolean;
}

export function GhostToggle({
  showGhosts,
  onToggle,
  hasGhosts = true,
}: GhostToggleProps) {
  if (!hasGhosts) return null;

  return (
    <TooltipProvider delayDuration={300}>
      <Tooltip>
        <TooltipTrigger asChild>
          <button
            onClick={() => onToggle(!showGhosts)}
            className={`flex h-7 w-7 items-center justify-center rounded transition-opacity hover:opacity-100 ${
              showGhosts ? 'opacity-100' : 'opacity-30'
            }`}
            aria-label="Toggle Ghost Objects"
          >
            <Ghost className="h-4 w-4 text-foreground" />
          </button>
        </TooltipTrigger>
        <TooltipContent
          side="top"
          className="flex items-center gap-2 border-border bg-background text-foreground"
        >
          <span>
            {showGhosts ? 'Hide Ghost Objects' : 'Show Ghost Objects'}
          </span>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
